var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"login-div"}},[_c('iframe',{staticClass:"login-iframe",attrs:{"id":"login-iframe","src":_vm.url}})])}
var staticRenderFns = []

export { render, staticRenderFns }